import { template } from "@ember/template-compiler";
export default template(`
  <button type='button' class='flex items-center text-gray-400 hover:text-gray-500 px-2 hover:underline' data-test-unvote-button ...attributes>
    <span class='text-xs'>
      Cancel
    </span>
  </button>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
